import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import { preworkDataStore, checkRequired } from 'src/store/preworkInfo';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ type = '', data }) => {
  const preworkPayload = preworkDataStore((state: any) => state.payload);
  const bindPreworkPayload = preworkDataStore((state: any) => state.bindPayload);
  const inpStatus = type === 'list' ? '_read' : '';

  // view type
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    bindPreworkPayload({ ...preworkPayload, [key]: e.target.value });
  };
  const inpChangeNumberEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value: any = e.target?.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    bindPreworkPayload({ ...preworkPayload, [key]: Number(value) });
  };
  const labelStyle = { width: '170px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className={['_comp_before_detail_content_div _active', inpStatus].join(' ')}>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'pins_health')}
            // inputRef={inpRef}
            label="건강보험료"
            labelPosition="left"
            value={addComma(preworkPayload.pins_health || 0)}
            required={type !== 'list' ? checkRequired('pins_health') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'pins_emp')}
            // inputRef={inpRef}
            label="고용보험료"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.pins_emp || 0)}
            required={type !== 'list' ? checkRequired('pins_emp') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>

      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tax_rural')}
            // inputRef={inpRef}
            label="농어촌특별세"
            status={inpStatus}
            labelPosition="left"
            value={addComma(preworkPayload.tax_rural || 0)}
            required={type !== 'list' ? checkRequired('tax_rural') : ''}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
